import { createFileRoute } from "@tanstack/react-router";
import AmazonGardenDeals from "@/pages/AmazonGardenDeals";

export const Route = createFileRoute("/deals/amazon-garden-deals")({
  component: AmazonGardenDeals,
});
